export default __webpack_public_path__ + "static/media/chaqueta-bombero-mujer.c3b24dd8.png";